import { BuilderConfig } from '../../types/Builder';

import BusinessHubCarouselProduct, { IMAGE_POSITION, ITEMS_POSITION, ProductCarouselProps } from './business-hub-carousel-product';

export const BusinessHubCarouselProductBuilderConfig = {
    name: 'Business Hub Carousel Product',
    inputs: [
        {
            name: 'title',
            type: 'string',
        },
        {
            name: 'subTitle',
            type: 'string',
        },
        {
            name: 'backgroundColor',
            type: 'color',
        },
        {
            name: 'colorText',
            type: 'color',
        },

        {
            name: 'colorPaginationBulletActive',
            type: 'color',
        },

        {
            name: 'positionItems',
            type: 'string',
            enum: Object.values(ITEMS_POSITION),
            defaultValue: ITEMS_POSITION.Left,
        },
        {
            name: 'items',
            type: 'list',
            subFields: [
                {
                    name: 'image',
                    type: 'file',
                    helperText: 'Use for mobile',
                },
                {
                    name: 'heightImageMobile',
                    type: 'number',
                },
                {
                    name: 'maxWidthImage',
                    type: 'number',
                },
                {
                    name: 'maxWidthImageMobile',
                    type: 'number',
                },
                {
                    name: 'imagePosition',
                    type: 'string',
                    enum: Object.values(IMAGE_POSITION),
                    defaultValue: IMAGE_POSITION.Center,
                },
                {
                    name: 'title',
                    type: 'html',
                },
                {
                    name: 'maxWidthTitle',
                    type: 'number',
                },
                {
                    name: 'description',
                    type: 'string',
                },
                {
                    name: 'ctaText',
                    type: 'string',
                    required: false,
                },
                {
                    name: 'ctaUrl',
                    type: 'url',
                    required: false,
                },
                {
                    name: 'openLinkInNewTab',
                    type: 'boolean',
                    defaultValue: true,
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<ProductCarouselProps> = {
    component: BusinessHubCarouselProduct,
    config: BusinessHubCarouselProductBuilderConfig,
};

export default builderConfig;
